// extracted by css-extract-rspack-plugin
export default {"hoverBackground":"_e1e269bb","active":"_1793485f","linkItem":"_76edd926"};